interface ConsentCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label: string;
  /** Fassung, auf die sich die Zustimmung bezieht - gehoert sichtbar an die Checkbox. */
  versionLabel?: string;
  linkLabel?: string;
  onLinkClick?: () => void;
}

export function ConsentCheckbox({
  checked,
  onChange,
  disabled,
  label,
  versionLabel,
  linkLabel,
  onLinkClick,
}: ConsentCheckboxProps) {
  return (
    <div className="bg-white/5 border border-white/10 rounded-xl p-3">
      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-0.5 w-5 h-5 flex-shrink-0 rounded border-white/30 bg-white/10 text-pp-orange focus:ring-pp-orange disabled:opacity-50"
        />
        <span className="text-white/90 text-sm">{label}</span>
      </label>
      <div className="flex items-center gap-3 mt-2 ml-8">
        {linkLabel && (
          <button
            type="button"
            onClick={onLinkClick}
            className="text-pp-orange text-sm underline hover:text-pp-orange/80"
          >
            {linkLabel}
          </button>
        )}
        {versionLabel && <span className="text-white/40 text-xs">{versionLabel}</span>}
      </div>
    </div>
  );
}
